module.exports = __webpack_public_path__ + "img/c_slider_portail_client.3d1b19c5.jpg";